<div>
  <div class="floating-label-container">
    <div [hidden]="readonly">
      <div
        style="
          position: relative;
          width: 100%;
          align-items: center;
          border: 1px solid #dddddd;
          border-radius: 4px;
        "
      >
        <div style="padding-top: 5px">
          <textarea
            id="{{ myId }}"
            #inputControl
            class="floatText"
            rows="{{ rows }}"
            cols="{{ cols }}"
            [(ngModel)]="boundValue"
            (keyup)="_handle_onKeyUp($event)"
            [style]="style"
            [style.width.%]="control_width_pct"
            [style.width.px]="control_width_px"
            (blur)="handle_onBlur($event)"
          ></textarea>
          <div
            [hidden]="!label || label == ''"
            class="floatLabel"
            style="margin-left: -1px"
          >
            {{ label }}
          </div>
          @if (helpVisible && helpText != '') {
            <div
              id="{{ myId }}_h"
              (mouseout)="hideHelp($event)"
              (click)="$event.stopPropagation()"
              class="contextHelpBox"
            >
              {{ helpText }}
            </div>
          }
          <div
            class="tb-validation-msg"
            [hidden]="
              !validationMsg || validationMsg == '' || (isValid && !required)
            "
          >
            <div
              for="inputControl"
              style="display: inline-block; margin-right: 15px"
              [hidden]="!required"
            >
              Required
            </div>
            <div
              for="inputControl"
              style="display: inline-block"
              [hidden]="isValid"
            >
              {{ validationMsg }}
            </div>
          </div>
        </div>
      </div>
      @if (helpText != '') {
        <div class="helpOverlay" (mouseover)="showHelp($event)">?</div>
      }
    </div>
    <div
      [hidden]="readonly"
      style="
        margin-top: -10px;
        font-size: 0.9em;
        color: #777777;
        font-style: italic;
      "
    >
      {{ hint }}
    </div>
    <div [hidden]="!readonly" style="padding: 0px 0px 0px 10px">
      {{ boundValue }}
    </div>
  </div>
  <div
    [className]="readonly || !hint || hint == '' ? 'invisibleText' : ''"
    style="
      text-align: right;
      margin-top: 0px;
      font-size: 0.9em;
      color: #777777;
      font-style: italic;
    "
  >
    &nbsp;{{ hint }}
  </div>
</div>
